(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const wrapper = this.closest('.header-wrapper');

      if (wrapper && wrapper.dataset.transparentHome === 'true') {
        const solidAfter = parseInt(wrapper.dataset.solidAfter || '40', 10);
        if (scrollTop > solidAfter) {
          wrapper.classList.add('is-solid');
        } else {
          wrapper.classList.remove('is-solid');
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function() {
    var audienceWrap = document.querySelector('[data-audience-toggle]');
    if (!audienceWrap) return;

    var btn = audienceWrap.querySelector('[data-audience-switch]');
    var adultLabel = audienceWrap.querySelector('[data-adult-label]');
    var babyLabel = audienceWrap.querySelector('[data-baby-label]');

    var adultUrl = audienceWrap.getAttribute('data-adult-url');
    var babyUrl = audienceWrap.getAttribute('data-baby-url');
    var defaultMode = audienceWrap.getAttribute('data-default-mode') || 'adult';

    function getPath(url) {
      try {
        return new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
      } catch(e) {
        return '';
      }
    }

    var adultPath = getPath(adultUrl);
    var babyPath = getPath(babyUrl);
    var currentPath = window.location.pathname.replace(/\/+$/, '');

    var isBaby = false;

    if (babyPath && currentPath.indexOf(babyPath) === 0) {
      isBaby = true;
    } else if (adultPath && currentPath.indexOf(adultPath) === 0) {
      isBaby = false;
    } else {
      isBaby = defaultMode === 'baby';
    }

    function renderState() {
      if (isBaby) {
        btn.classList.add('is-baby');
        babyLabel.classList.add('is-active');
        adultLabel.classList.remove('is-active');
      } else {
        btn.classList.remove('is-baby');
        adultLabel.classList.add('is-active');
        babyLabel.classList.remove('is-active');
      }
    }

    renderState();

    btn.addEventListener('click', function() {
      isBaby = !isBaby;
      renderState();
      window.location.href = isBaby ? babyUrl : adultUrl;
    });

    adultLabel.addEventListener('click', function() {
      window.location.href = adultUrl;
    });

    babyLabel.addEventListener('click', function() {
      window.location.href = babyUrl;
    });
  })();

  document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(
    ".header.header--middle-left.header--mobile-center.page-widths.header--has-menu.header--has-social.header--has-account"
  );

  if (!header) return;

  const stickyOffset = header.offsetTop;
  const headerHeight = header.offsetHeight;

  function handleStickyHeader() {
    if (window.scrollY > stickyOffset + 50) {
      header.classList.add("is-sticky");
      document.body.style.paddingTop = headerHeight + "px";
    } else {
      header.classList.remove("is-sticky");
      document.body.style.paddingTop = "";
    }
  }

  window.addEventListener("scroll", handleStickyHeader);
  handleStickyHeader();
});

  } catch(e) { console.error(e); }
})();
})();
